import React from 'react'
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
} from "@mui/material";
import instance from '../../Utils/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Deletepopup = ({ selectedBanner, deleteDialog, setdeleteDialog, setGetbanners }) => {

    const handleClose = () => {
        setdeleteDialog(false);
    }
    //delete banner
    const handleDeleteBanner = async () => {
        try {
            const response = await instance.delete(`/Banner/deleteBanner?banner_id=${selectedBanner?.bannerId}`)
            if (response.data.success === true) {
                toast.success(response?.data?.message)
                handleClose();
                setGetbanners(true)
            } else {
                toast.error(response?.data?.message)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message); // Handle errors
        }
    }
    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={deleteDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Delete Banner
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Typography>
                        Are you sure you want to delete the banner titled <strong>{selectedBanner?.name || "Unnamed Banner"}</strong>? This action cannot be undone.
                    </Typography>
                </DialogContent>
                <DialogActions >
                    <Button className="cancel-btn" onClick={handleClose}>No, Keep Banner</Button>
                    <Button className="add-btn" onClick={handleDeleteBanner}>Yes, Delete Banner</Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Deletepopup;